/**
 * Uses turbo to redirect user to a different path based on the value of an input field.
 * Designed for use with select tags with paths as values
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  handleSwitch(e) {
    const mode_path = e.target.value;

    fetch(mode_path, {
      headers: { Accept: "text/vnd.turbo-stream.html" },
    })
      .then((r) => r.text())
      .then((html) => {
        Turbo.renderStreamMessage(html);
        window.history.replaceState({}, "", mode_path);
      });
  }
}
